module.exports = __webpack_public_path__ + "img/animals_07_H.1ca4c0c1.webp";